import React, { useEffect, useState } from "react";
import GenericList from "../shared/components/GenericList";
import { GridColDef } from "@mui/x-data-grid";
import { Grid2 } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LineChart,
  Line,
} from "recharts";
import { bokimpanjifaUrl } from "../../configs/URL";

export interface Bokimpanjifa {
  id: number;
  Anaranana: string;
  Lot: string;
  Ref: string;
  Tel: string;
  Volana: string;
  herinandro_1_Alr: string;
  herinandro_1_Asb: string;
  herinandro_2_Alr: string;
  herinandro_2_Asb: string;
  herinandro_3_Alr: string;
  herinandro_3_Asb: string;
  herinandro_4_Asb: string;
  herinandro_4_Asb_001: string;
  Vola_voaloa: number;
  Daty: string;
  Sonia: string;
}

export const BokimpanjifaTable: React.FC = () => {
  const [data, setData] = useState<Bokimpanjifa[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Remplace ici par ton vrai endpoint
        const res = await fetch(bokimpanjifaUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();

        const mapped: Bokimpanjifa[] = json.results.map((r: any, index: number) => ({
          id: r._id || index,
          Anaranana: r.Anaranana,
          Lot: r.Lot,
          Ref: r.Ref,
          Tel: r.Tel,
          Volana: r.Volana,
          herinandro_1_Alr: r.herinandro_1_Alr,
          herinandro_1_Asb: r.herinandro_1_Asb,
          herinandro_2_Alr: r.herinandro_2_Alr,
          herinandro_2_Asb: r.herinandro_2_Asb,
          herinandro_3_Alr: r.herinandro_3_Alr,
          herinandro_3_Asb: r.herinandro_3_Asb,
          herinandro_4_Asb: r.herinandro_4_Asb,
          herinandro_4_Asb_001: r.herinandro_4_Asb_001,
          Vola_voaloa: Number(r.Vola_voaloa) || 0,
          Daty: r.Daty,
          Sonia: r.Sonia,
        }));

        setData(mapped);
      } catch (err: any) {
        setError(err.message || "Erreur de chargement");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Chargement…</div>;
  if (error) return <div style={{ color: "red" }}>Erreur: {error}</div>;

  const BokimpanjifaFields: GridColDef[] = [
    { field: "Anaranana", headerName: "Anaranana (Nom)", width: 180 },
    { field: "Lot", headerName: "Lot", width: 120 },
    { field: "Ref", headerName: "Réf.", width: 120 },
    { field: "Tel", headerName: "Téléphone", width: 140 },
    { field: "Volana", headerName: "Volana (Mois)", width: 130 },
    { field: "Vola_voaloa", headerName: "Vola voaloa (Payé)", width: 150, type: "number" },
    { field: "Daty", headerName: "Daty (Date)", width: 130 },
  ];

  // agrégation par mois pour les graphiques
  const groupedByMonth = Object.values(
    data.reduce((acc: any, item) => {
      if (!acc[item.Volana]) acc[item.Volana] = { Volana: item.Volana, total: 0, count: 0 };
      acc[item.Volana].total += item.Vola_voaloa;
      acc[item.Volana].count += 1;
      return acc;
    }, {})
  );

  return (
    <div style={{ padding: "16px" }}>
      <Grid2 container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid2 size={6}>
          <h3 style={{ textAlign: "center", marginBottom: 10 }}>
            Total des paiements par mois
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={groupedByMonth}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="Volana" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" name="Total payé" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </Grid2>

        <Grid2 size={6}>
          <h3 style={{ textAlign: "center", marginBottom: 10 }}>
            Moyenne de paiement par client
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={groupedByMonth}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="Volana" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="total" stroke="#8884d8" name="Total payé" />
            </LineChart>
          </ResponsiveContainer>
        </Grid2>
      </Grid2>

      <GenericList columns={BokimpanjifaFields} rows={data} />
    </div>
  );
};

export default BokimpanjifaTable;
